import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { Button, Grid, Link, Slide, Snackbar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CookiesConsentBar = ({ onAccept, open, url, isAuthenticated }) => {
  const theme = useTheme();

  return (
    <Snackbar
      open={open}
      slot={{ transition: Slide }}
      sx={{
        bottom: '0 !important',
        backgroundColor: theme.palette.primary.main,
        left: '0 !important',
        justifyContent: 'center',
        padding: '5px 0',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
          left: 0,
          right: 0,
          ...(isAuthenticated && {
            zIndex: 50,
            bottom: '3.5rem !important', // Adjust for the main menu bar height
          }),
        },
      }}
    >
      {/* We need a fragment to avoid the Snackbar spreading invalid props into the Grid */}
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
        <Grid
          size={{
            xs: 12,
            sm: 'auto',
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: theme.palette.cookiesConsent.text,
              lineHeight: '1.5',
              [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
              },
            }}
          >
            <FormattedTranslation id="cookies.consent.usage" />
          </Typography>
        </Grid>
        <Grid>
          <Link
            href={url}
            underline="always"
            sx={{
              color: theme.palette.cookiesConsent.text,
              lineHeight: '1.5',
              fontSize: theme.typography.pxToRem(13),
              margin: '0 15px',
              [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
                margin: '0 5px',
              },
            }}
          >
            <FormattedTranslation id="cookies.consent.moreInfo" />
          </Link>
        </Grid>
        <Grid>
          <Button
            size="small"
            variant="contained"
            onClick={onAccept}
            sx={{
              '& .MuiButton-label': {
                textTransform: 'uppercase',
              },
            }}
          >
            <FormattedTranslation id="general.ok" />
          </Button>
        </Grid>
      </Grid>
    </Snackbar>
  );
};

CookiesConsentBar.propTypes = {
  onAccept: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool,
};

export default CookiesConsentBar;
